import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';

import { HttpClient } from "@angular/common/http";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ReplaySubject, Subject } from "rxjs";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { ErrorHelper } from "../../shared/error.helper";
import { LieferantenGruppe } from "../../shared/lieferantengruppe.model";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { Fragebogen } from "../fragebogen/fragebogen.model";
import { OaseDeleteDialogComponent } from "../immerdrin/oase.delete.component";
import { RestServiceImpl } from "../immerdrin/rest.service.impl";
import { RestService } from "../immerdrin/rest.service.interface";
import { SelectFilterUtil } from "../immerdrin/select-filter.util";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { DataTablePipeLieferantenGruppe } from "./datapipelieferantengruppe";
import { FragebogenInsertEditComponent } from "./fragebogen.insertEdit.component";

const PATH_FILE = 'app/protected/verwaltungfragebogen/verwaltungfragebogen.component.ts';
const OBJ_LNG_NAME = 'fragebogen';
const BACKEND_PATH_PREFIX = 'fragebogen/';

@Component({
    selector: 'oase-verwaltungfragebogen',
    templateUrl: './verwaltungfragebogen.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, DataTablePipeLieferantenGruppe, RouterModule,
		NgxMatSelectSearchModule, FormsModule, ReactiveFormsModule, FlexModule]

})
export class VerwaltungfragebogenComponent extends Tabelle<Fragebogen> {

	// rechte: Kernrecht[] = new Array<Kernrecht>();

	typen: string[] = new Array<string>();
	lieferantenGruppen: LieferantenGruppe[] = new Array<LieferantenGruppe>();

	_selectsuche: string[] = new Array<string>();

	einleitungstextContent:string = "";
	schlusstextContent:string = "";

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredFragebogen: ReplaySubject<Fragebogen[]> = new ReplaySubject<Fragebogen[]>(1);

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
	  @Inject(L10N_LOCALE) public locale: L10nLocale,
	  @Inject(L10N_CONFIG) private config: L10nConfig,
	  public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/verwaltungfragebogen",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: "name",
				extraDataForAdding: { }
			}
		);
    this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen', this.translation.translate('fragebogen.verwaltung'));
		this.displayedColumns = ['name', 'typ', 'ablaufdatum', 'lieferantengruppe', 'admin'];
    this.title.setTitle(this.getTitle());
	}

	getTitle() {
		return this.translation.translate('fragebogen.title') + ' - ' + this.translation.translate('project.title');
	}

	extraInit() {
		this._logger.debug(PATH_FILE+' extraInit START');
    this.getTypen();
		this.getLieferantenGruppen();
		this._logger.debug(PATH_FILE+' super.extraInit CALL');
    super.extraInit();
    this._logger.debug(PATH_FILE+' extraInit END');
	}

	createNewElement() {
		return new Fragebogen();
	}

	loeschenSpalteName() {
		return "name";
	}

	getApiParams() {
		return "seite/all";
	}

	vorHinzufuegen(element) {
		element.alleLieferantenGruppen = this.lieferantenGruppen;
		element.typen = this.typen;
	}

	zeigeLoeschenMaske(element: any) {
		this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
	}

	zeigeHinzufuegenMaske() {
		this._zeigeHinzufuegenMaske(FragebogenInsertEditComponent);
	}

	zeigeBearbeitenMaske(element) {

		element.alleLieferantenGruppen = this.lieferantenGruppen;
		element.typen = this.typen;
		element.ablaufdatum = new Date(element.ablaufdatum);

		element.einleitungstextContent = element.einleitungstext; //damit im wysiwyg editor der gespeicherte Einleitungstext angezeigt und bearbeitet werden kann
	    element.schlusstextContent = element.schlusstext;

		this._zeigeBearbeitenMaske(element, FragebogenInsertEditComponent);
	}

	// such comparison is needed for mat-select
	compareMitId(item1, item2) {
		return item1 && item2 ? item1.id === item2.id : item1 === item2;
	}

	initLieferantenGruppe(row): boolean {
		SelectFilterUtil.initFilter(this.lieferantenGruppen, row, (lg, search) => { return lg.name.toLowerCase().indexOf(search) > -1 })
		return true;
	}

  private getTypen() {
    this._logger.debug(PATH_FILE + ' - getTypen Begin für URL: '+this.REST_API);

    this.http.get<string[]>(this.REST_API + '/getFragebogentypen/').subscribe({
      next: (data) => {
        this.typen = data;
        this._logger.debug(PATH_FILE + ' - getTypen End', this.typen);
      },
      error: (err) => {
        ErrorHelper.handleError(err,"Fehler beim holen der Fragebogentypen",this._logger, this.translation)
      },
      complete: () => {
        this._logger.debug(PATH_FILE + ' - Holen der Fragebogentypen abgeschlossen')
      }
    });
  }

  private getLieferantenGruppen() {
    this._logger.debug(PATH_FILE + ' - getLieferantenGruppen Begin für URL: '+this.REST_API);

    this.http.get<LieferantenGruppe[]>(this.REST_API + '/getLieferantengruppen/').subscribe({
      next: (data) => {
        this.lieferantenGruppen = data;
        this._logger.debug(PATH_FILE + ' - getLieferantenGruppen End', this.lieferantenGruppen);
      },
      error: (err) => {
        ErrorHelper.handleError(err,"Fehler beim holen der LieferantenGruppen",this._logger, this.translation)
      },
      complete: () => {
        this._logger.debug(PATH_FILE + ' - Holen der LieferantenGruppen abgeschlossen')
      }
    });
  }

	sendeMail(fragebogen: Fragebogen) {
    this._logger.log(PATH_FILE + ' - sendeMail Begin für URL: '+this.REST_API);
    this.http.get(this.REST_API + '/mailAussenden/'+fragebogen.id).subscribe({
      next: (data) => {
        this._logger.log(PATH_FILE + ' - mails senden End');
        this.openSnackBar(this.translation.translate(OBJ_LNG_NAME+'.mail_gesendet'));
      },
      error: (err) => {
        ErrorHelper.handleError(err,"Fehler beim Aussenden der Mails",this._logger, this.translation)
        this.openSnackBar(this.translation.translate(OBJ_LNG_NAME+'.mail_nicht_gesendet'));
      },
      complete: () => {
        this._logger.log(PATH_FILE + ' - Holen der Fragebogentypen abgeschlossen')
      }
    });
	}

	behandleLieferatnengruppenaenderungen(fragebogen: Fragebogen) {
		this._logger.log(PATH_FILE + ' - behandleLieferatnengruppenaenderungen BEGIN');
		this._logger.log(PATH_FILE + ' - behandleLieferatnengruppenaenderungen fragebogen: ', fragebogen);

		let snacknachricht = this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate('fragebogen.liste') });
		this.speichern(fragebogen, snacknachricht, false); // false ... Tabelle nicht neu laden
	}

  setzeBreadcrumb(fragebogen: Fragebogen){
  this._logger.log(PATH_FILE + ' SETZE BREADCRUMB FRAGEBOGEN');
  this.sessService.setFragebogen(fragebogen);
  }
}

